import React from "react";
import { FileText, X, Download, Loader2 } from "lucide-react";

/** Záchrana pro zablokovanou záložku: PDF je hotové a otevře se klikem
    na odkaz — to prohlížeč nikdy neblokuje. Na mobilu přes celou šířku nad
    dolní lištou, na desktopu vpravo dole. */
export default function PdfPripraveno({ url, nazev = "PDF", onClose }) {
  if (!url) return null;
  return (
    <div className="fixed z-50 left-3 right-3 bottom-[calc(84px+env(safe-area-inset-bottom))] md:left-auto md:right-6 md:bottom-6 md:w-[360px]"
      data-testid="pdf-pripraveno">
      <div className="card shadow-panel p-4 flex items-start gap-3">
        <span className="h-9 w-9 rounded-icon bg-accent/10 text-accent flex items-center justify-center shrink-0">
          <FileText size={18} />
        </span>
        <div className="min-w-0 flex-1">
          <div className="t-telo font-700 text-ink">{nazev} je připravené</div>
          <div className="t-meta text-muted mt-0.5">Prohlížeč nepovolil otevřít novou záložku automaticky.</div>
          <div className="flex flex-wrap gap-2 mt-3">
            <a href={url} target="_blank" rel="noreferrer" onClick={onClose} data-testid="pdf-otevrit"
              className="btn-primary tap">Otevřít PDF</a>
            <a href={url} download onClick={onClose} data-testid="pdf-stahnout"
              className="btn-ghost tap"><Download size={15} /> Stáhnout</a>
          </div>
        </div>
        <button onClick={onClose} aria-label="Zavřít" className="tap text-muted hover:text-ink shrink-0 -mt-1 -mr-1 p-1">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}

/** Čekání na PDF, když se po aktualizaci aplikace teprve zprovozňuje tisk
    (první PDF po Publish může trvat i pár minut). Okno se pak otevře samo. */
export function PdfCeka({ zobrazit }) {
  if (!zobrazit) return null;
  return (
    <div className="fixed z-50 left-3 right-3 bottom-[calc(84px+env(safe-area-inset-bottom))] md:left-auto md:right-6 md:bottom-6 md:w-[360px]"
      data-testid="pdf-ceka" role="status">
      <div className="card shadow-panel p-4 flex items-start gap-3">
        <span className="h-9 w-9 rounded-icon bg-[#fff6e8] text-[#a0610c] flex items-center justify-center shrink-0">
          <Loader2 size={18} className="animate-spin" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="t-telo font-700 text-ink">PDF se připravuje</div>
          <div className="t-meta text-muted mt-0.5">
            Aplikace se po aktualizaci připravuje. První PDF může trvat až 3 minuty — otevře se samo, nic nezavírej.
          </div>
        </div>
      </div>
    </div>
  );
}
